import PersonnelActions from 'common/redux/actions/personnel';

import Immutable from 'immutable';
import { MinimalPersonnel } from 'common/models/internal/MinimalPersonnel';

export const minimalPersonnel = (
    state = Immutable.fromJS({ minimalPersonnel: null }),
    action
) => {
    if (action.type === PersonnelActions.SET_MINIMAL_PERSONNEL) {
        const minimalPersonnel = action.params;
        return state.set(
            'minimalPersonnel',
            MinimalPersonnel.fromJS(minimalPersonnel)
        );
    } else {
        return state;
    }
};
